import React, { Component, createRef } from 'react';
import {
    SofaSelect,
    InputType,
    SofaFormControl,
    SofaFormControlDescriptionWithGtm,
    SofaFormFilter,
    SofaFormValidator,
    SofaFormWithGtm,
    getPropsForSofaInput
} from '@sofology/sofologycomponents';
import { AddressModel } from 'models';
import { analyticsHelper, errorToBasketErrorModel } from 'helpers';

export const ADDRESS_REQUIRED_ERROR_MESSAGE = 'Please either select an address from dropdown';

interface OwnProps {
    addresses: AddressModel[];
    onAddressChanged: (address: AddressModel | null) => void;
    ref?: React.RefObject<AddressSelectorType>;
    gtmFormName: string;
}

interface OwnPropsWithDefault {
    startControlIndex?: number;
}

interface OwnState {
    addressSelectorForm: SofaFormWithGtm<any>;
}

class AddressSelector extends Component<OwnProps & OwnPropsWithDefault, OwnState> {
    static defaultProps: Partial<OwnPropsWithDefault> = {
        startControlIndex: 0
    };

    constructor(props: OwnProps) {
        super(props);

        this.state = {
            addressSelectorForm: new SofaFormWithGtm<any>(
                {
                    addressSelector: {
                        name: 'addressSelector',
                        defaultValue: null,
                        filters: [this.keyToDeliveryAddressLookupItemFilter()],
                        validators: [this.addressSelectorRequiredValidator(ADDRESS_REQUIRED_ERROR_MESSAGE)],
                        ref: createRef<SofaSelect>(),
                        inputType: InputType.Selector,
                        gtmFieldName: 'addressResults'
                    } as SofaFormControlDescriptionWithGtm<AddressModel | null>
                },
                updateStateFunc => {
                    this.setState(updateStateFunc);
                },
                'addressSelectorForm',
                () => this.state,
                this.props.gtmFormName,
                analyticsHelper.sendToGoogleMessageAboutInputChangeCompleted.bind(analyticsHelper),
                errorToBasketErrorModel,
                this.props.startControlIndex
            )
        };
    }

    componentDidMount(): void {
        // without this first changing in selector cannot be tracked inside componentDidUpdate
        this.state.addressSelectorForm.controls.addressSelector.setValue(null);
    }

    componentDidUpdate(prevProps: OwnProps, prevState: OwnState): void {
        if (prevState.addressSelectorForm.controls.addressSelector.value !== this.state.addressSelectorForm.controls.addressSelector.value) {
            this.props.onAddressChanged(this.state.addressSelectorForm.controls.addressSelector.value);
        }
    }

    render(): JSX.Element {
        const addresses = this.props.addresses.map(d => {
            let key = d.toString();

            return {
                title: key,
                value: key
            };
        });

        return (
            <div className='address-selector'>
                <SofaSelect
                    label='Select an address *'
                    {...getPropsForSofaInput(this.state.addressSelectorForm.controls.addressSelector)}
                    value={
                        this.state.addressSelectorForm.controls.addressSelector.value !== null ?
                            this.state.addressSelectorForm.controls.addressSelector.value.toString()
                            : ''
                    }
                    items={addresses}
                />
            </div>
        );
    }

    keyToDeliveryAddressLookupItemFilter = (): SofaFormFilter<AddressModel | null> =>
        (address: string | AddressModel | null) => {
            if (typeof address === 'string') {
                let selectedAddress = this.props.addresses.find(a => a.toString() === address);

                return selectedAddress ?? null;
            }

            return address;
        };

    addressSelectorRequiredValidator = (errorMessage: string): SofaFormValidator<AddressModel | null> => {
        return (value: AddressModel | null) => {
            return Promise.resolve(value === null ? errorMessage : null);
        };
    };

    validate = (): Promise<SofaFormControl<any>[]> => {
        return this.state.addressSelectorForm.validate();
    };
}

export default AddressSelector;
export type AddressSelectorType = AddressSelector;